import { FieldDefinition } from "./fieldDefinitions";

export interface PatientImplantDto {
  implantId: number;
  patientId: number;
  encounterId?: number | null;
  serialNumber: string;
  lotNumber: string;
  anatomicLocation: string;
  active: boolean;
  materialType: string;
  manufacturer: string;
  modelName: string;
}

export interface ImplantOption {
  implantId: number;
  idDescr: string;
}

export const getImplantOptions = (implants: Array<ImplantOption> = []) =>
  implants.map((imp) => ({
    label: imp.idDescr ?? "Χωρίς περιγραφή",
    value: imp.implantId,
  }));

export const patientImplantFormData: string[] = [
  "implantId",
  "patientId",
  "encounterId",
  "serialNumber",
  "lotNumber",
  "anatomicLocation",
  "active",
  "materialType",
  "manufacturer",
  "modelName",
];

export const getPatientImplantFields = (
  options: Array<{ value: string | number; label: string }> = [],
): FieldDefinition[] => [
  {
    name: "implantId",
    label: "Μοντέλο Εμφυτεύματος",
    type: "select",
    required: true,
    options,
  },
  {
    name: "serialNumber",
    label: "Σειριακός Αριθμός (Serial Number)",
    type: "text",
    required: true,
  },
  { name: "lotNumber", label: "Αριθμός Lot", type: "text", required: true },
  {
    name: "anatomicLocation",
    label: "Ανατομική Θέση",
    type: "text",
    required: true,
  },
];

//export const patImplantKeyId = "documentId" as const;
export const patientImplantFields = getPatientImplantFields();

export const patientImplantFilters = patientImplantFields.filter((f) =>
  ["implantId", "serialNumber", "anatomicLocation"].includes(f.name),
);
